export default __webpack_public_path__ + "images/5e12a63da24935ea995af2d825cc7287-anime.webp";